import { Button, Col, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { sushiLunchProductsService } from "../../../shared/services";
import { ISushiLunchProduct } from "../../../redux/@types/sushiLunchProduct";
import { useProducts } from "../../products";
import { useUpdateStatusSushiLunchProduct } from "../hooks/useUpdateStatusSushiLunchProduct";
import { useRemoveSushiLunchProduct } from "../hooks/useRemoveSushiLunchProduct";
import { useParams } from "react-router-dom";

const { Title } = Typography;

interface Props {
  fetchQuery?: any;
}

export const TableSushiLunchProducts = ({ fetchQuery }: Props) => {
  const { setTableProps } = useProducts();
  const { rule_id } = useParams();
  const { updateStatus, isLoading } = useUpdateStatusSushiLunchProduct();
  const { showDeleteConfirm } = useRemoveSushiLunchProduct();

  const columns: TableColumns<ISushiLunchProduct> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Producto",
      width: 5,
      dataIndex: ["product", "name"],
      key: "id",
      filterType: "filterByID",
    },
    {
      title: "Estado",
      width: 10,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                updateStatus(
                  item.status === "active" ? "inactive" : "active",
                  item.id
                );
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={() =>
                showDeleteConfirm(item.id, item.product?.name || "")
              }
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<ISushiLunchProduct>
      columns={columns}
      scroll={{}}
      fetchQueryProps={{
        rule_sushi_lunch_id: rule_id,
        $sort: { id: -1 },
        ...fetchQuery,
      }}
      service={sushiLunchProductsService}
      onLoad={setTableProps}
    />
  );
};
